export const fleetTableColumns = [
    {id: "fleetNumber", label: "Fleet No."},
    {id: "fleetVendor", label: "Fleet Vendor"},
    {id: "plate", label: "Plate No."},
    {id: "station", label: "Station"},
    {id: "reason", label: "Reason"},
]

export const daTableColumns = [
    {id: "badge", label: "Badge"},
    {id: "fullName", label: "Full Name"},
    {id: "transporterID", label: "Transporter ID"},
    {id: "driverLicense", label: "Driver License"},
]

export const rabbitTableColumns = [
    {id: "date", label: "Date"},
    {id: "station", label: "Station"},
    {id: "driver", label: "Driver"},
    {id: "serialNumber", label: "Serial Number"},
]

export const dollyTableColumns = [
    {id: "date", label: "Date"},
    {id: "station", label: "Station"},
    {id: "driver", label: "Driver"},
    {id: "serialNumber", label: "Serial Number"},
]